// src/components/Layout.js
import React, { useState, useContext } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../App';
import './Layout.css';

function Layout() {
  const { loginUser, handleLogout } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊', path: '/dashboard' },
    { id: 'new-booking', label: 'New Booking', icon: '📝', path: '/new-booking' },
    { id: 'all-bookings', label: 'All Bookings', icon: '📋', path: '/all-bookings' },
    { id: 'upcoming', label: 'Upcoming', icon: '📅', path: '/upcoming' },
  ];

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleLogoutClick = () => {
    handleLogout();
    navigate('/login');
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="layout-container">
      {/* Top Navbar */}
      <nav className="top-navbar">
        <div className="nav-left">
          <button 
            className="menu-toggle"
            onClick={toggleSidebar}
          >
            ☰
          </button>
          <span className="brand">🏨 Shivpuri Resort</span>
        </div>
        <div className="nav-right">
          <span className="user-name">👤 {loginUser}</span>
          <button onClick={handleLogoutClick} className="logout-btn">
            🚪 Logout
          </button>
        </div>
      </nav>

      <div className="app-container">
        {/* Sidebar - Fixed Left */}
        <aside className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
          <div className="sidebar-content">
            <div className="sidebar-header">
              <div className="sidebar-logo">🏨</div>
              <div className="sidebar-brand">SR</div>
            </div>
            
            <nav className="sidebar-nav">
              {navItems.map(item => (
                <button
                  key={item.id}
                  className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
                  onClick={() => handleNavigation(item.path)}
                >
                  <span className="nav-icon">{item.icon}</span>
                  <span className="nav-label">{item.label}</span>
                </button>
              ))}
            </nav>

            <div className="sidebar-footer">
              <div className="sidebar-user">
                <span className="user-avatar">👤</span>
                <div>
                  <div className="user-name-sidebar">{loginUser}</div>
                  <div className="user-role">Administrator</div>
                </div>
              </div>
            </div>
          </div>
        </aside>

        {/* Main Content */}
        <main className={`main-content ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default Layout;